var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9178 47.7421C14.4554 49.1221 4.56517 44.982 1.3887 34.5145C-2.2713 22.6708 1.25852 7.2523 12.5101 1.86978C26.3095 -4.46128 45.1116 6.02849 47.8231 22.15C49.735 36.7166 35.7756 46.5703 23.9215 47.7383",
    fill: "#FFC505"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7092_22087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8H8V40H40V8Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7092_22087)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7092_22087",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8H8V40H40V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7092_22087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4469 36.0596H31.4289C31.9371 36.0596 32.3575 35.6455 32.3575 35.131V14.9522C32.3575 14.444 31.9371 14.0236 31.4289 14.0236V34.2024C31.4289 34.7106 31.0085 35.131 30.5003 35.131H17.5183C17.5183 35.6392 17.9387 36.0596 18.4469 36.0596ZM17.5183 31.8871C17.5183 32.1443 17.7254 32.3514 17.9826 32.3514H23.5481C23.8054 32.3514 24.0124 32.1443 24.0124 31.8871C24.0124 31.6298 23.8054 31.4228 23.5481 31.4228H17.9826C17.7254 31.4228 17.5183 31.6298 17.5183 31.8871ZM17.5183 29.1075C17.5183 29.3647 17.7254 29.5718 17.9826 29.5718H28.185C28.4422 29.5718 28.6493 29.3647 28.6493 29.1075C28.6493 28.8502 28.4422 28.6432 28.185 28.6432H17.9826C17.7254 28.6432 17.5183 28.8502 17.5183 29.1075ZM17.5183 26.3279C17.5183 26.5851 17.7254 26.7922 17.9826 26.7922H28.185C28.4422 26.7922 28.6493 26.5851 28.6493 26.3279C28.6493 26.0706 28.4422 25.8636 28.185 25.8636H17.9826C17.7254 25.8636 17.5183 26.0706 17.5183 26.3279ZM26.7983 20.1098C26.7983 20.6683 26.3465 21.1828 25.4932 21.1828C24.8344 21.1828 24.1944 20.8377 23.8054 20.0345L23.0775 20.6306C23.5105 21.553 24.3701 22.0298 25.2548 22.1051V23.0902H25.9763V22.08C27.0744 21.9169 27.8587 21.1514 27.8587 20.0659C27.8587 19.3255 27.4822 18.7922 26.8611 18.4157C26.3654 18.1145 25.4995 17.7506 25.123 17.5185C24.7905 17.3114 24.5018 17.0228 24.5018 16.5773C24.5018 15.9812 24.9975 15.611 25.6187 15.611C26.083 15.611 26.6164 15.8181 27.043 16.3828L27.7081 15.7616C27.2626 15.1467 26.6665 14.8392 26.0579 14.7326V13.8165H25.3426V14.7138C24.1944 14.8267 23.4665 15.6298 23.4665 16.6338C23.4665 17.393 23.8995 17.9389 24.5332 18.3341C25.0038 18.6353 25.5873 18.8612 26.0705 19.1059C26.472 19.3318 26.8109 19.6204 26.8109 20.1161L26.7983 20.1098ZM31.4289 36.9883H18.4469C17.4242 36.9883 16.5897 36.16 16.5897 35.131H15.6611C15.1528 35.131 14.7324 34.7169 14.7324 34.2024V17.0479H18.905C19.9277 17.0479 20.7622 16.2196 20.7622 15.1906V11.0181H30.5003C31.0085 11.0181 31.4289 11.4322 31.4289 11.9467V13.0949C32.4516 13.0949 33.2861 13.9232 33.2861 14.9522V35.131C33.2861 36.1538 32.4579 36.9883 31.4289 36.9883ZM18.9112 16.1255H15.203L19.8399 11.4887V15.1969C19.8399 15.7051 19.4195 16.1255 18.9112 16.1255Z",
    fill: "#00625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit4);
export default __webpack_public_path__ + "static/media/benefit-4.ed2f35f4b7168a0983d36234168a3e40.svg";
export { ForwardRef as ReactComponent };